<template>
  <div class="channel-form-page">
    <Head title="Edit Channel" />

    <div class="mb-6">
      <nav class="mb-2 flex items-center gap-2 text-sm text-gray-500">
        <Link href="/channel" class="font-medium text-brand-600 hover:text-brand-800">Channel</Link>
        <span>/</span>
        <span class="text-gray-700">Edit</span>
      </nav>
      <p class="text-xs font-semibold uppercase tracking-[0.14em] text-brand-500">Operations</p>
      <h1 class="mt-1 text-3xl font-bold tracking-tight text-brand-900">Edit Channel</h1>
      <p class="mt-1.5 text-sm text-gray-500">Update channel code, name, and active status.</p>
    </div>

    <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      <form class="p-6 md:p-8" @submit.prevent="update">
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
          <text-input v-model="form.agtCd" :error="form.errors.agtCd" class="w-full" label="Channel Code" />
          <text-input v-model="form.name" :error="form.errors.name" class="w-full" label="Name" />

          <div class="rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 md:col-span-2">
            <label class="mb-2 block text-xs font-semibold uppercase tracking-wide text-gray-500">Status</label>
            <div class="flex items-center gap-3">
              <button
                type="button"
                class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
                :class="form.status === 'Y' ? 'bg-brand-600' : 'bg-gray-200'"
                @click="toggleStatus"
              >
                <span
                  class="inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                  :class="form.status === 'Y' ? 'translate-x-5' : 'translate-x-0'"
                />
              </button>
              <span
                class="inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold"
                :class="form.status === 'Y' ? 'bg-teal-50 text-teal-700' : 'bg-gray-100 text-gray-600'"
              >
                {{ form.status === 'Y' ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>
        </div>

        <div class="mt-8 flex items-center justify-end gap-3 border-t border-gray-100 pt-6">
          <Link
            href="/channel"
            class="rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </Link>
          <loading-button
            :loading="form.processing"
            class="inline-flex items-center justify-center rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700"
            type="submit"
          >
            Update Channel
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        agtCd: this.channel.agtCd,
        name: this.channel.name,
        status: this.channel.status || 'Y',
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/channel/${this.channel.agtCd}`)
    },
    toggleStatus() {
      this.form.status = this.form.status === 'Y' ? 'N' : 'Y'
    },
  },
}
</script>
